export default __webpack_public_path__ + "static/media/b20.b868be38.png";